/**
 * -1 means "use pricing chart / legacy fallback" in wallet billing.
 */
export const toChargeFormValue = (value: number | undefined | null): number =>
	value === null || value === undefined ? -1 : value

export const normalizeClientChargeForSave = (
	value: number | string | null | undefined
): number => {
	if (value === null || value === undefined || value === '') {
		return -1
	}
	const parsed = typeof value === 'number' ? value : Number(value)
	return Number.isFinite(parsed) ? parsed : -1
}

export const formatClientChargeLabel = (
	value: number | undefined | null
): string =>
	value === null || value === undefined || value === -1
		? 'Default (pricing chart)'
		: String(value)
